let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("etx49")).then(() => parcelRequire('eK5YJ'));